const Favorite = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3652 3.75H16.3662C19.1975 3.75017 21.4492 5.91963 21.4492 8.54395C21.4492 10.99 20.0057 13.2977 18.2783 15.2275C16.7538 16.9302 14.9229 18.431 13.4043 19.5879L12.7744 20.0625C12.6136 20.1821 12.4112 20.25 12.1992 20.25C12.0403 20.25 11.8866 20.2121 11.752 20.1426L11.624 20.0625C10.1061 18.9313 8.12772 17.3818 6.44922 15.5889L6.11816 15.2275C4.39229 13.2975 2.94922 10.99 2.94922 8.54395C2.94926 5.91963 5.20092 3.75017 8.03223 3.75C9.46153 3.75 10.754 4.3086 11.6777 5.20215L12.2002 5.70801L12.7217 5.20215C13.1947 4.74351 13.76 4.37781 14.3857 4.12793C15.0117 3.87801 15.6851 3.74902 16.3652 3.75Z"
        stroke="#BABABA"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default Favorite;
